/* Chrôma Premium Motion — TEAM ORIGINATOR */
(function () {
  if (window.__chpmLoaded) return;
  window.__chpmLoaded = true;
  var html = document.documentElement;
  var on = function () { return html.classList.contains('ch-motion') && html.classList.contains('chpm'); };
  var fine = window.matchMedia && matchMedia('(hover: hover) and (pointer: fine)').matches;
  var design = window.Shopify && Shopify.designMode;

  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      if (!e.isIntersecting) return;
      e.target.classList.add('chpm-in');
      io.unobserve(e.target);
      if (e.target.__chpmIn) e.target.__chpmIn();
    });
  }, { threshold: 0.18, rootMargin: '0px 0px -8% 0px' }) : null;
  function watch(el, cb) { if (cb) el.__chpmIn = cb; if (io) io.observe(el); else { el.classList.add('chpm-in'); if (cb) cb(); } }

  function split(h) {
    if (h.classList.contains('chpm-split')) return;
    var i = 0;
    (function walk(node) {
      [].slice.call(node.childNodes).forEach(function (n) {
        if (n.nodeType === 3) {
          var parts = n.textContent.split(/(\s+)/), frag = document.createDocumentFragment();
          parts.forEach(function (p) {
            if (!p) return;
            if (/^\s+$/.test(p)) { frag.appendChild(document.createTextNode(' ')); return; }
            var w = document.createElement('span'); w.className = 'chpm-w';
            var s = document.createElement('span'); s.textContent = p; s.style.setProperty('--i', i++);
            w.appendChild(s); frag.appendChild(w);
          });
          n.parentNode.replaceChild(frag, n);
        } else if (n.nodeType === 1 && n.tagName !== 'BR') walk(n);
      });
    })(h);
    h.classList.add('chpm-split');
  }

  function countUp(b) {
    var txt = b.textContent.trim();
    var m = txt.match(/^([^0-9]*)([0-9][0-9,]*)(.*)$/);
    if (!m || /[:/]/.test(txt)) return;
    var to = parseInt(m[2].replace(/,/g, ''), 10), t0 = null;
    b.textContent = m[1] + '0' + m[3];
    function step(t) {
      if (t0 === null) t0 = t;
      var p = Math.min((t - t0) / 1600, 1);
      b.textContent = m[1] + Math.round(to * (1 - Math.pow(1 - p, 4))).toLocaleString() + m[3];
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  function marquee(press) {
    if (design || press.classList.contains('chpm-marquee')) return;
    var items = [].slice.call(press.children);
    if (items.length < 2) return;
    var track = document.createElement('div'); track.className = 'chpm-track';
    for (var r = 0; r < 4; r++) {
      items.forEach(function (it) {
        var c = it.cloneNode(true);
        c.classList.remove('chp-rv', 'is-in'); c.removeAttribute('style');
        [].slice.call(c.attributes).forEach(function (a) { if (a.name.indexOf('data-shopify') === 0) c.removeAttribute(a.name); });
        if (r) c.setAttribute('aria-hidden', 'true');
        track.appendChild(c);
      });
    }
    press.innerHTML = '';
    press.appendChild(track);
    press.style.setProperty('--chpm-dur', Math.max(28, items.length * 9) + 's');
    press.classList.add('chpm-marquee');
  }

  var px = [];
  function addPx(el, amt) {
    if (el.hasAttribute('data-chpm-px')) return;
    var img = null;
    for (var k = 0; k < el.children.length; k++) if (el.children[k].tagName === 'IMG') { img = el.children[k]; break; }
    if (!img) return;
    el.setAttribute('data-chpm-px', '');
    px.push({ el: el, img: img, amt: amt });
  }
  var ticking = false, bar = null;
  function frame() {
    ticking = false;
    var vh = window.innerHeight;
    px.forEach(function (p) {
      var r = p.el.getBoundingClientRect();
      if (r.bottom < -100 || r.top > vh + 100) return;
      var c = (r.top + r.height / 2 - vh / 2) / vh;
      p.img.style.translate = '0 ' + (c * p.amt).toFixed(1) + 'px';
    });
    if (bar) {
      var h = document.documentElement.scrollHeight - vh;
      bar.style.transform = 'scaleX(' + (h > 0 ? Math.min(window.scrollY / h, 1) : 0) + ')';
    }
  }
  function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(frame); } }

  function magnetic(btn) {
    if (btn.__chpmMag) return; btn.__chpmMag = 1;
    btn.addEventListener('pointermove', function (e) {
      var r = btn.getBoundingClientRect();
      var x = (e.clientX - r.left - r.width / 2) / r.width, y = (e.clientY - r.top - r.height / 2) / r.height;
      btn.style.translate = (x * 10).toFixed(1) + 'px ' + (y * 8).toFixed(1) + 'px';
    });
    btn.addEventListener('pointerleave', function () { btn.style.translate = ''; });
  }
  function tilt(card) {
    if (card.__chpmTilt) return; card.__chpmTilt = 1;
    card.addEventListener('pointermove', function (e) {
      var r = card.getBoundingClientRect();
      var x = (e.clientX - r.left) / r.width - .5, y = (e.clientY - r.top) / r.height - .5;
      card.style.transition = 'transform .25s ease-out';
      card.style.transform = 'perspective(900px) rotateY(' + (x * 7).toFixed(2) + 'deg) rotateX(' + (-y * 7).toFixed(2) + 'deg)';
    });
    card.addEventListener('pointerleave', function () {
      card.style.transition = 'transform .9s cubic-bezier(.16,1,.3,1)';
      card.style.transform = '';
    });
  }

  function init(scope) {
    if (!on()) return;
    var root = scope && scope.querySelectorAll ? scope : document;

    root.querySelectorAll('.chp .chp-h').forEach(function (h) { split(h); watch(h); });

    root.querySelectorAll('.chp-hero').forEach(function (hero) {
      hero.querySelectorAll('.chp-h .chpm-w > span').forEach(function (s) { s.style.setProperty('--d', '250ms'); });
      var h = hero.querySelector('.chp-h'); if (h) h.classList.add('chpm-in');
      var m = hero.querySelector('.chp-hero__media'); if (m) addPx(m, 60);
      requestAnimationFrame(function () { requestAnimationFrame(function () { hero.classList.add('chpm-ready'); }); });
    });

    root.querySelectorAll('.chp .chp-media').forEach(function (m) {
      if (m.closest('.chp-hero') || m.closest('.chp-result') || m.classList.contains('chpm-curtain')) return;
      m.classList.add('chpm-curtain'); watch(m);
    });
    root.querySelectorAll('.chp-split > .chp-media').forEach(function (m) { addPx(m, 50); });

    root.querySelectorAll('.chp-press').forEach(marquee);
    root.querySelectorAll('.chp-steps, .chp-bundle, [data-chp-reviews], .chp-video').forEach(function (el) { watch(el); });
    root.querySelectorAll('.chp-stat b').forEach(function (b) { watch(b, function () { countUp(b); }); });

    if (fine) {
      root.querySelectorAll('.chp .chp-btn').forEach(magnetic);
      root.querySelectorAll('.chp-story').forEach(tilt);
    }

    if (!bar && document.querySelector('.chp')) {
      bar = document.createElement('div'); bar.className = 'chpm-progress'; bar.setAttribute('aria-hidden', 'true');
      document.body.appendChild(bar);
    }
    frame();
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (e) {
    px = px.filter(function (p) { return document.contains(p.el); });
    init(e.target);
  });
})();
